import { useQuery } from "@tanstack/react-query";
import type { Member } from "@/lib/types";

/** The firm's staff, for assignee pickers and names. Empty if the list can't be read. */
export function useMembers(): Member[] {
  const { data } = useQuery<Member[]>({ queryKey: ["/api/firm/members"], staleTime: 60_000 });
  return data ?? [];
}

/** Staff names by user id. */
export function useMemberNames(): Map<string, string> {
  return new Map(useMembers().map((m) => [m.userId, m.name]));
}
